import React from "react";
import CDialog from "./CDialog";
import CButton from "./CButton";

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Are you sure?",
  description = "",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmClass="bg-blue-500 text-white hover:bg-blue-700 border border-blue-500 border-blue-700 px-4 py-2 rounded-lg",
  cancelClass="bg-white text-blue-500 hover:text-white hover:bg-blue-500 border border-blue-500 px-4 py-2 rounded-lg",
  loading = false,
  children,
}) => (
  <CDialog open={open} onClose={onClose}>
    <div>
      <h3 className="text-xl font-semibold text-gray-800 mb-4">{title}</h3>
      {description && <p className="text-gray-600 mb-6">{description}</p>}
      {children}
      <div className="flex justify-end gap-3">
        {cancelText && (
          <CButton
            onClick={onClose}
            className={cancelClass}
            disabled={loading}
          >
            {cancelText}
          </CButton>
        )}
        {confirmText && (
          <CButton
            onClick={onConfirm}
            className={confirmClass}
            disabled={loading}
          >
            {loading ? "Processing..." : confirmText}
          </CButton>
        )}
      </div>
    </div>
  </CDialog>
);

export default ConfirmationDialog; 